module.exports = __webpack_public_path__ + "static/media/welcome-async.5e49291b.webp";